import { AssetTree, TreeCategory } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import BranchTree from "./AssetTree/OptionsTree/BranchTree";
import SegmentTree from "./AssetTree/OptionsTree/SegmentTree";
import ClientTree from "./AssetTree/OptionsTree/ClientTree";
import VehicleTree from "./AssetTree/OptionsTree/VehicleTree";
import DriverTree from "./AssetTree/OptionsTree/DriverTree";
import { useAppDispatch } from "@store";
import useAssetTree from "./AssetTree/useAssetTree";

const BRANCH = "branch";
const SEGMENT = "segment";
const CLIENT = "client";
const VEHICLE = "vehicle";
const DRIVER = "driver";

const CustomAssetTree = () => {
  const dispatch = useAppDispatch();
  const TreeCategoryComponent = TreeCategory as React.ComponentType<any>;

  const [isOpen, setIsOpen] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState(BRANCH);

  const handleChangeCategories = (categoryId: string) => setCurrentCategoryId(categoryId);

  const {
    filterOptions,
    selectedBranches,
    selectedClients,
    selectedSegments,
    selectedDrivers,
    selectedVehicles,

    setSelectedVehicles,
    setSelectedDrivers,
    setSelectedSegments,
    setSelectedClients,
    setSelectedBranches,
  } = useAssetTree();

  return (
    <AssetTree
      minWidth={0}
      maxWidth={350}
      currentCategoryId={currentCategoryId}
      onCategoryChange={handleChangeCategories}
      isOpen={isOpen}
      onToggleTree={(open) => {
        setIsOpen(open);
      }}
      useOffscreen={false}
    >
      <TreeCategoryComponent
        key={BRANCH}
        id={BRANCH}
        label="Filial"
        icon="rioglyph-building"
        hasSelection={!!selectedBranches.length}
      >
        <BranchTree
          filterOptions={filterOptions}
          selectedBranches={selectedBranches}
          setSelectedBranches={(items) => dispatch(setSelectedBranches(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={SEGMENT}
        id={SEGMENT}
        label="Segmento"
        icon="rioglyph-role-management"
        hasSelection={!!selectedSegments.length}
      >
        <SegmentTree
          filterOptions={filterOptions}
          selectedSegments={selectedSegments}
          setSelectedSegments={(items) => dispatch(setSelectedSegments(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={CLIENT}
        id={CLIENT}
        label="Cliente"
        icon="rioglyph-transfer"
        hasSelection={!!selectedClients.length}
      >
        <ClientTree
          filterOptions={filterOptions}
          selectedClients={selectedClients}
          setSelectedClients={(items) => dispatch(setSelectedClients(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={VEHICLE}
        id={VEHICLE}
        label="Veiculo"
        icon="rioglyph-truck"
        hasSelection={!!selectedVehicles.length}
      >
        <VehicleTree
          filterOptions={filterOptions}
          selectedVehicles={selectedVehicles}
          setSelectedVehicles={(items) => dispatch(setSelectedVehicles(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={DRIVER}
        id={DRIVER}
        label="Motorista"
        icon="rioglyph-driver"
        hasSelection={!!selectedDrivers.length}
      >
        <DriverTree
          filterOptions={filterOptions}
          selectedDrivers={selectedDrivers}
          setSelectedDrivers={(items) => dispatch(setSelectedDrivers(items))}
        />
      </TreeCategoryComponent>
    </AssetTree>
  );
};

export default CustomAssetTree;
